// src/templates/empanadaclub/Dashboard.jsx
// Dashboard personalizado para cliente específico
// Solo muestra: Métricas del Mes y Acciones Rápidas

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';
import useAuthStore from '../../store/authStore';

// Hooks personalizados
import { useDashboardData } from '../../hooks/useDashboardData';
import { useBusinessAnalyzer } from '../../hooks/useBusinessAnalyzer';

// Componentes del Dashboard
import DashboardHeader from './DashboardHeader';
import BusinessMetricsGrid from '../../components/dashboards/BusinessMetricsGrid';
import QuickActionsGrid from '../../components/dashboards/QuickActionsGrid';

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const userId = user.userId;

  // Hooks personalizados
  const {
    marcasStats,
    loading,
    dashboardMetrics
  } = useDashboardData(userId);

  const { analyzingBusiness, analyzeBusiness } = useBusinessAnalyzer(userId, navigate);

  // Handlers
  const handleNavigateToAnalytics = () => {
    navigate('/statistics/dashboard');
  };

  const handleNavigateToMarketingHistory = () => {
    navigate('/marketing-chain/history');
  };

  const handleNavigateToSocialContent = () => {
    navigate('/social-content');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <FaSpinner className="animate-spin text-blue-500 text-4xl mx-auto mb-4" />
          <p className="text-gray-600">Cargando tu dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-full mx-auto px-2 sm:px-4 py-4 sm:py-6 overflow-x-hidden">
        {/* Header con mensaje personalizado */}
        <DashboardHeader />

        {/* Solo Métricas del Mes y Acciones Rápidas */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 sm:gap-6 mb-4 sm:mb-8">
          {/* Métricas del Mes */}
          <div className="lg:col-span-3 w-full order-1 lg:order-1">
            <div className="bg-white rounded-lg shadow-sm p-3 sm:p-4 md:p-5 lg:p-6">
              <div className="mb-3 sm:mb-4">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900">Métricas del Mes</h3>
              </div>
              <BusinessMetricsGrid marcasStats={marcasStats} dashboardMetrics={dashboardMetrics} />
            </div>
          </div>

          {/* Acciones Rápidas */}
          <div className="lg:col-span-1 w-full order-2 lg:order-2">
            <QuickActionsGrid
              onAnalyzeBusiness={analyzeBusiness}
              onNavigateToAnalytics={handleNavigateToAnalytics}
              onNavigateToMarketingHistory={handleNavigateToMarketingHistory}
              onNavigateToSocialContent={handleNavigateToSocialContent}
              analyzingBusiness={analyzingBusiness}
              generatingIdea={false}
              ideaGenerationCooldown={false}
              cooldownTimeRemaining={0}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

